<template>
  <div class="settings">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <div class="col-sm-12">
                    <h3 class="page-title">Billing</h3>
                  </div>
                </div>
              </div>
              <!-- /Page Header -->
              <!-- {{bankArr}} -->
              <div
                class="alert alert-warning"
                v-if="bankArr.member_bank_id==''"
              >*Payout will be temporarily paused upon bank account information changes until the verification process of new bank info is completed.</div>
              <form @submit.prevent="updateBank" class="was-validated">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>
                        Bank Account Information
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="memberSessionArr.name"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>
                        Bank Name
                        <span class="text-danger">*</span>
                      </label>
                      <select v-model="bankArr.member_bank_id" class="form-control">
                        <option :value="''">Options</option>
                        <option
                          v-for="(row,index) in bankList"
                          :key="index"
                          :value="row.bank_id"
                        >{{row.bank_name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Branch</label>
                      <input
                        autocomplete="off"
                        class="form-control"
                        type="text"
                        v-model="bankArr.member_bank_branch"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>
                        Account No
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        autocomplete="off"
                        class="form-control"
                        type="text"
                        v-model="bankArr.member_bank_account_no"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>
                        Your Password for Confirmation
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        autocomplete="off"
                        class="form-control"
                        v-model="member_password_confirmation"
                        type="password"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div class="submit-section">
                  <a @click.prevent="$router.push('/') " class="btn btn-light submit-btn">Cancel</a>
                  <button :disabled="isLoading" class="btn btn-primary submit-btn">Save</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion
  },
  computed: {
    memberSessionArr() {
      return this.$store.state.login.memberSession;
    }
  },
  data() {
    return {
      member_password_confirmation: "",
      bankList: [],
      isLoading: false,
      bankArr: {
        member_bank_id: "",
        member_bank_city: "",
        member_bank_branch: "",
        member_bank_account_no: "",
        member_bank_account_name: "",
        update_datetime: 0
      }
    };
  },
  created() {
    this.getBank();
    this.getBankList();
  },
  methods: {
    updateBank() {
      this.isLoading = true;
      let dataParam = {
        member_password_confirmation: this.member_password_confirmation,
        member_bank_id: this.bankArr.member_bank_id,
        member_bank_name: this.bankArr.member_bank_name,
        member_bank_branch: this.bankArr.member_bank_branch,
        member_bank_account_no: this.bankArr.member_bank_account_no
      };
      this.$store
        .dispatch("member/updateBank", dataParam)
        .then(response => {
          this.isLoading = false;

          this.getBank();

          this.$fire({
            title: "Success",
            text: response["msg"],
            type: "success",
            timer: 2000
          });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getBankList() {
      this.$store.dispatch("login/getBankList").then(response => {
        let { data } = response;
        this.bankList = data;
      });
    },
    getBank() {
      this.$store.dispatch("login/getBank").then(response => {
        let { data } = response;
        this.bankArr = data;
        if (this.bankArr.member_bank_id == 0) {
          this.bankArr.member_bank_id = "";
        }
      });
    }
  },
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "settings"
};
</script>


// WEBPACK FOOTER //
// src/views/settings/billing.vue